import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const resolveUrl = (url) => (url?.startsWith("/") ? `${BACKEND}${url}` : url);

export const api = axios.create({ baseURL: API, withCredentials: true });

export const apiError = (err, fallback) => {
    const d = err?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return fallback;
};
